export const MERCHANTS_APP = {
    SIDEBAR_MERCHANT_ACCOUNT_LINK: "sidebar-merchant-account-link",
    SIDEBAR_MEMBERS_LINK: "sidebar-members-link",
    SIDEBAR_SETTINGS_LINK: "sidebar-settings-link",
    HAMBURGER_MENU_DRIVE_LINK: "hamburger-menu-drive-link",
    HAMBURGER_MENU_MERCHANT_ADMIN_LINK: "hamburger-menu-merchant-admin-link",
    HAMBURGER_MENU_MERCHANT_HELP_LINK: "hamburger-menu-help-link",
};
